const DEFAULT_ROW_KEYS = [
  'qa-row-1',
  'qa-row-2',
  'qa-row-3',
  'qa-row-4',
  'qa-row-5',
  'qa-row-6',
];

interface ReportQaSkeletonProps {
  /** Number of Q&A placeholder rows (default 6). */
  rowCount?: number;
  /**
   * When `bare`, omit the outer white card — for nested use inside an
   * existing `.v3-report-content-card`. Default wraps in the card.
   */
  variant?: 'card' | 'bare';
}

const AnswerLegendPlaceholders = () => (
  <>
    <div className="d-flex align-items-center gap-2 mb-2">
      <span
        className="placeholder rounded-1 flex-shrink-0"
        style={{ width: 14, height: 14 }}
      />
      <span className="placeholder rounded col-5" />
    </div>
    <div className="d-flex align-items-center gap-2 mb-2">
      <span
        className="placeholder rounded-1 flex-shrink-0"
        style={{ width: 14, height: 14 }}
      />
      <span className="placeholder rounded col-7" />
    </div>
    <div className="d-flex align-items-center gap-2 mb-1">
      <span
        className="placeholder rounded-1 flex-shrink-0"
        style={{ width: 14, height: 14 }}
      />
      <span className="placeholder rounded col-4" />
    </div>
    <span
      className="placeholder rounded col-10 d-block ms-4"
      style={{ height: '0.7rem' }}
    />
  </>
);

/** Green-region Q&A: white card with template title + question/answer rows. */
const ReportQaSkeleton = ({
  rowCount = 6,
  variant = 'card',
}: ReportQaSkeletonProps) => {
  const rowKeys = DEFAULT_ROW_KEYS.slice(0, Math.max(1, rowCount));

  const body = (
    <div className="placeholder-glow">
      <h4 className="semibold my-1" style={{ marginTop: '0.2rem' }}>
        <span
          className="placeholder rounded"
          style={{ width: 160, height: '1.25rem' }}
        />
      </h4>
      <hr className="my-2" />
      <div className="ao_reportContainer">
        {rowKeys.map((key) => (
          <div className="ao_reportQues" key={key}>
            <div className="row">
              <div className="col-md-4">
                <div className="d-flex align-items-center gap-2 mb-2">
                  <span className="placeholder rounded col-8" />
                  <span
                    className="placeholder rounded-circle flex-shrink-0"
                    style={{ width: 14, height: 14 }}
                  />
                </div>
                <span
                  className="placeholder rounded col-10 d-block"
                  style={{ height: '0.8rem' }}
                />
              </div>
              <div className="col-md-8 ao_factpat">
                <AnswerLegendPlaceholders />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  if (variant === 'bare') {
    return body;
  }

  return <div className="row v3-report-content-card">{body}</div>;
};

export default ReportQaSkeleton;
